import { render, staticRenderFns } from "./PersonRegister.vue?vue&type=template&id=c076ca8a"
import script from "./PersonRegister.vue?vue&type=script&lang=js"
export * from "./PersonRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports